<template>
  <div class="stockkind-zujian-box">
    <el-dialog title="添加货物类型" :visible.sync="show" :close-on-click-modal="false" custom-class="common-dia-class">
      <p class="title"><span class="font-red">*</span> 货物种类</p>
      <ul class="ul-list">
        <li
          v-for="val in stockKindList"
          :key="val.typeCode"
          @click="handleClickStockkind(val)"
          :class="{ active: stockkindActiveId == val.typeCode }"
        >
          {{ val.typeName }}
        </li>
      </ul>
      <template v-if="showMoreKind">
        <div class="mt-20">
          <div v-show="!stockSencodListHideStatus">
            <p class="title">二级种类</p>
            <ul class="ul-list">
              <li
                v-for="val in stockSecondKindList"
                v-show="val.display == 1"
                :key="val.typeCode"
                @click="handleClickStockSecondkind(val)"
                :class="{ active: stockSecondKindActiveId == val.typeCode }"
              >
                {{ val.typeName }}
              </li>
            </ul>
          </div>
          <p class="title mt-20">货物型号</p>
          <div class="mt-20 num-box">
            <el-input
              type="text"
              placeholder="请输入"
              v-model.trim="stockThirdKindName"
              class="input-custom"
              :disabled="stockkindActiveId == 99"
              :maxlength="30"
              show-word-limit
            >
            </el-input>
          </div>
        </div>
        <div class="mt-10">
          <span
            class="localdata-style"
            v-for="val in stockThirdKindList"
            :key="val.typeCode"
            @click="handleUseStockKind(val)"
          >
            {{ val.typeName }}
            <i class="sub-del" @click.stop="handleStockKindDel(val.typeCode)"></i>
          </span>
        </div>
        <div slot="footer" class="dialog-footer flex-between">
          <div class="dialog-flex-row">
            <div class="title mr-10">货物名称:</div>
            <div>{{ stockKindNameShow }}</div>
          </div>
          <el-button type="primary" @click="handleConfirm" :disabled="stockkindActiveId == 99">确定</el-button>
        </div>
      </template>

      <template v-if="stockkindActiveId == 99">
        <div class="mt-20 num-box">
          <el-input
            type="text"
            placeholder="必填，请输入货物种类"
            v-model.trim="selfStockName"
            class="input-custom"
            :maxlength="30"
            show-word-limit
          >
          </el-input>
        </div>
        <div slot="footer" class="dialog-footer flex-between">
          <div class="dialog-flex-row">
            <div class="title mr-10">货物名称:</div>
            <div>{{ selfStockName }}</div>
          </div>
          <el-button type="primary" @click="submitStockName">确定</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
/*
 *<stock-kind :stock-info.sync="stockKind" width="150px"></stock-kind>
 *width|String 输入框长度
 * callback|Function 回调函数
 */
import { WUYI } from '@/api/common';
import axios from '@/api/axiosNew';
import api from '@/api/settings.new.api';
import { commonEventTracking } from '@/utils';

export default {
  name: 'StockKind',
  data() {
    return {
      show: false,
      selfStockName: '', // 其他货物类型
      stockKindListAll: [], // 所有类型数据
      stockKindList: [], // 一级
      stockSecondKindList: [], // 二级
      stockThirdKindList: [], // 三级
      showMoreKind: false,
      stockkindActiveId: '', // 一级选中
      stockkindActiveName: '', // 一级名称
      stockSecondKindActiveId: '', // 二级选中
      stockSecondKindActiveName: '', // 二级名称
      stockThirdKindId: '', // 三级id
      stockThirdKindName: '', // 三级名称

      goodsItem: {},
      goodsList: [],
      stockReg: /^[0-9a-zA-Z\u4e00-\u9fa5\-\—\_\/\%]+$/ //中文英文数字 "-"，"_"，"—"，"/"，"%"
    };
  },
  props: {
    queryType: {
      type: Number,
      default: 0
    }
  },
  created() {},
  computed: {
    stockSencodListHideStatus() {
      if (
        this.stockSecondKindList.length == 0 ||
        (this.stockSecondKindList.length == 1 && this.stockSecondKindList[0].display == 0)
      ) {
        return true;
      }
      return false;
    },
    stockKindNameShow() {
      let name = '';
      name = this.stockkindActiveName;
      if (this.stockSecondKindActiveName && this.stockSecondKindActiveId) {
        name = name + '/' + this.stockSecondKindActiveName;
      }
      if (this.stockThirdKindName) {
        name = name + '/' + this.stockThirdKindName;
      }
      return name;
    }
  },
  methods: {
    // 显示弹框
    openDia() {
      commonEventTracking('addStockKindPage', 'page', 'pltUserBehavior');
      this.stockkindActiveId = ''; // 一级选中
      this.stockkindActiveName = ''; // 一级名称
      this.stockSecondKindActiveId = ''; // 二级选中
      this.stockSecondKindActiveName = ''; // 二级名称
      this.stockThirdKindId = ''; // 三级id
      this.stockThirdKindName = ''; // 三级名称
      this.stockKindList = []; // 一级
      this.stockSecondKindList = []; // 二级
      this.stockThirdKindList = []; // 三级
      this.showMoreKind = false;
      this.selfStockName = '';
      this.queryStockKind(() => {
        this.show = true;
      });
    },
    // 查询货源类型
    queryStockKind(callback) {
      axios.post(api.stockTypeQryAll).then(res => {
        this.stockKindListAll = res.data.data;
        if (this.stockKindListAll.length == 0) return;
        this.handlestockKindData(callback);
      });
    },
    // 货源类型组装
    handlestockKindData(callback) {
      this.stockKindList = [];
      let map = this.stockKindListAll.reduce((acc, val) => {
        acc[val.typeCode] = val;
        return acc;
      }, {});
      this.stockKindListAll.forEach(val => {
        if (val.level != 1) {
          let parent = map[val.parentCode];
          if (parent) {
            if (!parent.children) {
              parent.children = [val];
            } else {
              parent.children.push(val);
            }
          }
        } else {
          this.stockKindList.push(val);
        }
      });
      if (callback && typeof callback === 'function') callback();
    },
    // 返回二级没有选中时的item
    getDefaultCode() {
      let firstList = this.stockKindList.filter(item => {
        return item.typeCode == this.stockkindActiveId;
      });

      if (firstList.length > 0 && firstList[0].children) {
        let secondItem = firstList[0].children.filter(item => {
          return item.display == 0;
        });
        if (secondItem.length > 0) {
          return secondItem[0];
        } else {
          return { typeName: '', typeCode: '', children: [] };
        }
      } else {
        return { typeName: '', typeCode: '', children: [] };
      }
    },
    // 一级点击
    handleClickStockkind(item) {
      const { typeCode, typeName } = item;
      // 选择其他
      if (typeCode == 99) {
        this.showMoreKind = false;
        this.stockThirdKindName = '';
        this.stockkindActiveId = typeCode;
        this.stockSecondKindActiveId = this.getDefaultCode().typeCode;
        this.stockSecondKindList = [];
        return;
      }
      this.selfStockName = '';
      this.stockkindActiveId = typeCode;
      this.stockkindActiveName = typeName;
      if (!this.showMoreKind) this.showMoreKind = true;
      this.stockSecondKindList = item.children || [];
      this.stockSecondKindActiveId = this.getDefaultCode().typeCode;
      this.stockSecondKindActiveName = this.getDefaultCode().typeName;
      this.stockThirdKindList = this.getDefaultCode().children || [];
      this.stockThirdKindName = '';
    },
    // 二级点击
    handleClickStockSecondkind(item) {
      const { typeCode, typeName } = item;
      if (typeCode == this.stockSecondKindActiveId) {
        this.stockSecondKindActiveId = this.getDefaultCode().typeCode;
        this.stockSecondKindActiveName = this.getDefaultCode().typeName;
        this.stockThirdKindList = this.getDefaultCode().children || [];
      } else {
        this.stockSecondKindActiveId = typeCode;
        this.stockSecondKindActiveName = typeName;
        this.stockThirdKindList = item.children || [];
      }
      this.stockThirdKindName = '';
    },
    // 三级快捷点击
    handleUseStockKind(item) {
      this.stockThirdKindName = item.typeName;
      this.stockThirdKindId = item.typeCode;
    },
    // 删除三级
    handleStockKindDel(typeCode) {
      axios.post(api.stockTypeDelete, { typeCode }).then(res => {
        this.$message.success('删除成功');
        this.queryStockKind(() => {
          let stockSecondKindList = this.stockKindList.filter(item => {
            return item.typeCode == this.stockkindActiveId;
          });
          if (stockSecondKindList.length > 0 && stockSecondKindList[0].children) {
            this.stockSecondKindList = stockSecondKindList[0].children;

            let stockThirdKindList = this.stockSecondKindList.filter(item => {
              return item.typeCode == this.stockSecondKindActiveId;
            });
            if (stockThirdKindList.length > 0 && stockThirdKindList[0].children) {
              this.stockThirdKindList = stockThirdKindList[0].children;
            } else {
              this.stockThirdKindList = [];
            }
          } else {
            this.stockSecondKindList = [];
            this.stockThirdKindList = [];
          }
        });
      });
    },
    // 保存
    handleConfirm() {
      if (this.stockThirdKindName && !this.stockReg.test(this.stockThirdKindName)) {
        this.$message.error('货物类型格式错误，请检查是否含有特殊字符');
        return;
      }
      commonEventTracking('addStockKindPageSaveBtn', 'btn', 'pltUserBehavior');
      let filArr = this.stockThirdKindList.filter(el => el.typeName === this.stockThirdKindName) || [];
      if ((this.stockThirdKindName && this.stockThirdKindId && filArr.length > 0) || !this.stockThirdKindName) {
        this.saveCommonGoods(this.stockThirdKindId);
      } else {
        let postData = {
          stockFirstKind: this.stockkindActiveId,
          stockSecondKind: this.stockSecondKindActiveId ? this.stockSecondKindActiveId : this.getDefaultCode().typeCode,
          typeName: this.stockThirdKindName
        };

        axios.post(api.stockTypeQueryOrSave, postData).then(res => {
          let typeCode = res.data.typeCode;
          this.saveCommonGoods(typeCode);
        });
      }
    },
    saveCommonGoods(typeCode = '') {
      let opts = {
        stockKind: this.stockkindActiveId,
        stockKindName: this.stockkindActiveName
      };
      // 有二级
      if (this.stockSecondKindActiveId && this.stockSecondKindActiveId != this.getDefaultCode().typeCode) {
        opts.stockSecondKind = this.stockSecondKindActiveId;
        opts.stockSecondName = this.stockSecondKindActiveName;
        // 有三级
        if (this.stockThirdKindName) opts.stockThirdName = this.stockThirdKindName;
      } else {
        // 有三级
        if (this.stockThirdKindName) {
          opts.stockSecondKind = this.getDefaultCode().typeCode;
          opts.stockSecondName = this.getDefaultCode().typeName;
          opts.stockThirdName = this.stockThirdKindName;
        }
      }
      if (typeCode) opts.stockThirdKind = typeCode;
      axios.post(api.commonGoodsAdd, { ...opts, queryType: this.queryType }).then(res => {
        this.show = false;
        this.$emit('callback', res.data);
      });
    },
    submitStockName() {
      if (this.selfStockName == '') {
        this.$message.error('请输入货物类型');
        return;
      }
      if (!this.stockReg.test(this.selfStockName)) {
        this.$message.error('货物类型格式错误，请检查是否含有特殊字符');
        return;
      }
      this.returnData('99', this.selfStockName);
    },
    returnData(id, name) {
      let opts = {
        stockKind: id,
        stockKindName: name
      };
      axios.post(api.commonGoodsAdd, { ...opts, queryType: this.queryType }).then(res => {
        this.show = false;
        this.$emit('callback', res.data);
      });
    }
  },
  watch: {}
};
</script>
<style>
.stockkind-zujian-box .default-input .el-input__inner {
  cursor: pointer;
}
.stockkind-zujian-box .default-input:hover .el-input__icon {
  cursor: pointer;
  color: rgb(131, 165, 137);
}

.stockkind-zujian-box .hover-icon:hover .el-icon-caret-bottom:before {
  content: '\E607';
}
.stockkind-zujian-box .ul-list li {
  display: inline-block;
  padding: 0 20px;
  margin-bottom: 20px;
  cursor: pointer;
}
.stockkind-zujian-box .inputItem {
  cursor: pointer;
}
.stockkind-zujian-box .localdata {
  padding-bottom: 10px;
  margin-bottom: 10px;
}
.stockkind-zujian-box .localdata-style {
  position: relative;
  display: inline-block;
  margin: 0 10px 10px 0;
  padding: 0 5px 0 10px;
  cursor: pointer;
  color: #47c26e;
  border: 1px solid #bfeed4;
  box-sizing: border-box;
  text-align: left;
  line-height: 26px;
}
.stockkind-zujian-box .sub-del {
  opacity: 0;
  display: inline-block;
  margin-left: 5px;
  width: 10px;
  height: 10px;
  background: url('../assets/img/stock/ico_hylx_del@2x.png') no-repeat;
  background-size: 10px 10px;
  text-align: right;
}
.stockkind-zujian-box .localdata-style:hover .sub-del {
  opacity: 1;
}
.stockkind-zujian-box .common-dia-class {
  width: 600px;
}
.stockkindname-class {
  width: 400px;
}
.stockkind-zujian-box .title {
  padding: 2px 0;
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 400;
  color: #aaaaaa;
  min-width: 72px;
}
.stockkind-zujian-box .ul-list li {
  padding: 0 10px;
  margin: 0 20px 20px 0;
  height: 28px;
  line-height: 28px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #e9e9e9;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
}
.stockkind-zujian-box .ul-list .active {
  padding: 0 10px;
  line-height: 28px;
  color: #1cc466;
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  background: #01d28e;
  border-radius: 4px;
  border: none;
}
.stockkind-zujian-box .dialog-flex-row {
  display: flex;
  text-align: left;
  padding-right: 30px;
}
.stockkind-zujian-box .num-box {
  position: relative;
}
.stockkind-zujian-box .num {
  position: absolute;
  right: 10px;
  top: 2px;
}
.stockkind-zujian-box .input-custom .el-input__inner {
  padding-right: 60px;
}
.category-title-style {
  display: flex;
  flex-direction: row;
}
.category-title-style span {
  color: red;
}
.goods-category-bottom {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>
